export default __webpack_public_path__ + "static/media/item-coverColor.a8209fca.png";